<template>
  <screen-loading></screen-loading>
</template>

<script>
import aes256 from 'aes256';
import enums from '@/utils/enums';
import { USER, UNIT, CONFIG } from '@/utils/constants';
import { getItem, setItem, clearStore } from '@/services/storage';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { setLGPDConsentBanner } from '@/services/lgpdSecuriti';
import {
  setToken,
  setAdminPreview,
  removeAdminPreview,
  validateToken,
  setAccessType,
} from '@/services/auth';
import { ROLES } from '../utils/constants';

export default {
  components: {
    ScreenLoading,
  },

  created() {
    this.loginByAdminPreview();
  },

  methods: {
    async loginByAdminPreview() {
      clearStore();

      this.$store.commit(UNIT.MUTATE, []);
      this.$store.dispatch(UNIT.SELECT, null);

      removeAdminPreview();

      const hashUndecoded = this.$router.currentRoute.params.hash;

      const hash = decodeURIComponent(hashUndecoded);

      const { user, admin, token, userRole } = JSON.parse(
        aes256.decrypt(process.env.STORAGE_ENCRYPT_KEY, hash)
      );
      const params = {
        username: user,
        userRole,
        ignoreClient: 1,
      };

      const headers = {
        Authorization: token,
        Tenant: this.$store.getters[CONFIG.GET].tenantId,
      };

      const result = await this.requestService(
        `${process.env.AUTH_API_URL}/user/getUser`,
        'GET',
        {
          params,
          auth: false,
          customHeaders: headers,
        }
      );

      if (result) {
        setAdminPreview(admin);

        setAccessType(enums.accessTypes.admin);

        sessionStorage.setItem('logged', true);
        setToken(token, { keepLogged: false });

        if (userRole == ROLES.SYNDIC_ROLE) {
          const syndic = result;
          this.$store.commit(USER.MUTATE_USER, syndic);
          await this.$store.dispatch(UNIT.SYNDIC_PRODUCTS, syndic);
          this.$router.push({ name: 'syndicSelectProduct' });
        } else {
          this.$store.commit(USER.MUTATE_USER, result.user);
          this.$router.push({ name: 'selectUnit' });
        }

        setLGPDConsentBanner(result?.user?._id || result?._id);
        this.createTrace(this.enums.logTraceActions.loginByAdmin);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/AdminPreview.vue